export default class PillTaken {

	static findPill (id, pills) {
		id = parseInt(id)
		for (let pill of pills) {
			if (parseInt(pill.id) === id) {
				return pill
			}
		}
		return null
	}

	static processRow (row, pills) {
		const pill = PillTaken.findPill(row.pill_id, pills)
		return {
			...row,
			pill
		}
	}

	static processResponse (data, pills) {
		const result = []
		data.forEach(row => {
			result.push(PillTaken.processRow(row, pills))
		})
		return result
	}
}



// WEBPACK FOOTER //
// ./src/classes/PillTaken.js